<template>
  <li class="onhover-dropdown">
    <div class="notification-box">
      <feather type="bell" @click="notification_open()"></feather
      >
      <span class="badge badge-pill badge-secondary">{{ commentsArray.length }} </span>
    </div>
    <div
        class="onhover-show-div notification-dropdown"
        :class="{ active: notification }"
    >
      <h6 class="f-18 mb-0 dropdown-title">Notitications</h6>
      <ul>
        <li class="b-l-primary border-4" :key="comment.id" v-for="comment in commentsArray">

          <div class="row">
            <div class="col-9">
              <p @click="openComment(comment)" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ comment.comment }}</p>
            </div>
            <div class="col-3">
              <p><span class="font-danger">10 min.</span></p>
            </div>
          </div>
        </li>
        <li><a class="f-w-700" href="#">Clear all</a></li>
      </ul>
    </div>
  </li>
</template>

<script>

export default {
  name: 'Notifications',
  props: {
    commentsArray: {
      default: function () {
        return []
      },
      type: Array
    }
  },
  data() {
    return {
      notification: false,
    };
  },

  methods: {

    async openComment(comment) {

      this.$store.dispatch('shared/setLoading', true)
      let res = await this.$store.dispatch('plan/loadStepTree', comment.step_id)

      this.$router.push(
          {
            name: 'ProjectPlan',
            params: {
              id: res.project,
              module: res.module
            },
            query: {
              'section': res.section,
              'assignment': res.assignment
            }
          })
    },

    notification_open() {
      this.notification = !this.notification;
    },
  },
};
</script>
